import _sfc_main from "./index97.js";
/* empty css        */
/* empty css        */
import _export_sfc from "./index63.js";
const ProductSearch = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c1a178ce"]]);
export {
  ProductSearch as default
};
//# sourceMappingURL=index38.js.map
